// extracted by mini-css-extract-plugin
export var icon = "_5m-1";
export var subtext = "_5m-0";